var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTariffs = function SvgTariffs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.125.894a.75.75 0 0 0-1.166 0L1.077 6.932a.75.75 0 0 0 .583 1.222h1.756v5.68a.75.75 0 0 0 1.5 0v-6.43a.75.75 0 0 0-.75-.75h-.935l3.31-4.096 3.312 4.096h-.936a.75.75 0 0 0-.75.75v2.161a.759.759 0 0 0-.001.055v7.346H6.409a.75.75 0 0 0-.583 1.222l4.882 6.038a.75.75 0 0 0 1.138.033l3.282-3.613a.75.75 0 0 0-1.11-1.009l-2.694 2.966-3.344-4.137h.936a.75.75 0 0 0 .75-.75v-2.161a.76.76 0 0 0 .001-.055V8.154h1.757a.75.75 0 0 0 .583-1.222L7.125.894Z",
    fill: "#697077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.792 12.421V9.265c0-.873-1.768-1.578-3.946-1.578s-3.944.706-3.946 1.578v6.313c.002.871 1.767 1.578 3.946 1.578 2.18 0 3.945-.707 3.946-1.578V9.265",
    stroke: "#697077",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 9.265c0 .871 1.767 1.578 3.946 1.578 2.18 0 3.945-.707 3.945-1.578M13.9 12.42c0 .872 1.767 1.58 3.946 1.58 2.18 0 3.946-.708 3.946-1.58",
    stroke: "#697077",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTariffs;